import _ from 'lodash'
import type { Procedure } from '../../../app-core/lib/procedure/Procedure'
import type {
    Type_ILocationFocusList,
    Type_IProcessedCalendarEvent,
    Type_TProcessedFocusListLocation,
    Type_TStats,
} from '../../zap/Type/Type.hive'

export function getFocusListsForLocation(focusListLookup: Type_ILocationFocusList[], locationId: number) {
    return focusListLookup.filter((fl) => fl.locations.find((flLoc) => flLoc.id === locationId) !== undefined)
}

export function includesDate(focusList: Type_ILocationFocusList, date: Date) {
    const start = new Date(focusList.range.startDate)
    const startOfDay = new Date(start.getFullYear(), start.getMonth(), start.getDate())
    const end = new Date(focusList.range.endDate)

    return date >= startOfDay && date < end
}

export function getFocusListStats(
    ownLocations: Type_TProcessedFocusListLocation[],
    focusList: Type_ILocationFocusList,
    eventsLookup: Type_IProcessedCalendarEvent[],
    campaignsLookup: Procedure[]
): Type_TStats {
    const statArray = ownLocations.map((location) =>
        getFocusListLocationStats(location, focusList, eventsLookup, campaignsLookup)
    )

    return {
        toSchedule: _.sumBy(statArray, 'toSchedule'),
        scheduled: _.sumBy(statArray, 'scheduled'),
        completed: _.sumBy(statArray, 'completed'),
    }
}

export function getFocusListLocationStats(
    location: Type_TProcessedFocusListLocation,
    focusList: Type_ILocationFocusList,
    eventsLookup: Type_IProcessedCalendarEvent[],
    campaignsLookup: Procedure[]
): Type_TStats {
    const focusListCampaigns = new Set(
        campaignsLookup.filter((campaign) => campaign.focusLists.includes(focusList.id)).map((c) => c.id)
    )

    const totalCallCount = location.callQuantity

    const events = eventsLookup.filter(
        (event) => event.location === location.id && focusListCampaigns.has(event.campaign)
    )

    const completed = events.filter((event) => event.complete || event.hasLocalReport).length

    const scheduled = events.length - completed

    return {
        toSchedule: Math.max(totalCallCount - events.length, 0),
        scheduled,
        completed,
    }
}
